import React from 'react';
function ReportFooter({ reportId }) {
    const css = `
        #footer {
            padding: 0 !important; 
            -webkit-print-color-adjust: exact !important;
            --webkit-print-color-adjust:exact !important;
            print-color-adjust: exact !important;
        }
    `;
    return (React.createElement("div", { id: 'wrap-footer', className: 'wrap-footer d-none' },
        React.createElement("style", null, css),
        React.createElement("div", { className: "footer-section", style: { color: '#b4b4b4', fontSize: '10px', width: '100%', textAlign: 'center', display: 'flex', justifyContent: reportId ? 'space-between' : 'flex-end', backgroundColor: '#efefef'
            } },
            reportId && React.createElement("div", { style: { paddingLeft: 10 } }, reportId),
            React.createElement("div", { className: "footer-text", style: {
                    width: '4%',
                    fontWeight: 400,
                    color: '##b4b4b4',
                    borderLeft: 'solid 2px #b4b4b4',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff'
                } },
                React.createElement("div", { className: "pageNumber" }),
                React.createElement("span", { style: { padding: '0 1px' } }, "/"),
                React.createElement("div", { className: "totalPages" })))));
}
export default ReportFooter;
